import { render, staticRenderFns } from "./PushNotificationBody.vue?vue&type=template&id=44bfd70c&scoped=true&"
import script from "./PushNotificationBody.vue?vue&type=script&lang=js&"
export * from "./PushNotificationBody.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationBody.vue?vue&type=style&index=0&id=44bfd70c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bfd70c",
  null
  
)

export default component.exports